module.exports = __webpack_public_path__ + "media/images/flags/ca-baec597e8001408cfd21104e94e03f77.png";